import { type TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Title, VSpacingContainer, Divider, Button } from '@hh.ru/magritte-ui';

import { useApplicantLoginContext } from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/context';
import { AuthMethod } from 'src/components/AccountLogin/types';
import ContactPhones from 'src/components/ContactPhones';
import Messengers from 'src/components/ContactPhones/Messengers';
import SupportChatPlate from 'src/components/SupportChatPlate';
import { useIsZarplataPlatform } from 'src/hooks/usePlatform';

const TrlKeys = {
    title: {
        info: 'auth.twoFactor.noAccessEmail.info',
        codeNotFound: 'login.form.codeNotFound',
    },
    action: {
        loginByPassword: 'login.action.by.password',
        goBack: 'auth.twoFactor.noAccessEmail.back',
    },
};

const TwoFactorGetHelpStep: TranslatedComponent = ({ trls }) => {
    const { authMethod, onPrevStep, onStepReplace } = useApplicantLoginContext();
    const isZp = useIsZarplataPlatform();

    const handleLoginByPasswordButtonClick = (): void => {
        onStepReplace('enter-password');
    };

    const handleGoBackButtonClick = (): void => {
        onPrevStep();
    };

    return (
        <VSpacingContainer default={24}>
            <Title Element="h2" size="medium" alignment="center" dataQaTitle="title-description">
                {authMethod === AuthMethod.ByCode ? trls[TrlKeys.title.codeNotFound] : trls[TrlKeys.title.info]}
            </Title>
            {!isZp && (
                <VSpacingContainer default={12}>
                    <SupportChatPlate />
                    <Messengers />
                </VSpacingContainer>
            )}
            <ContactPhones showHeader={false} formatted />
            <VSpacingContainer default={12}>
                {authMethod === AuthMethod.ByCode && (
                    <div>
                        <Divider mode="horizontal" marginTop={20} marginBottom={20} />
                        <Button
                            size="large"
                            style="accent"
                            mode="secondary"
                            data-qa="no-code-login-by-password"
                            stretched
                            onClick={handleLoginByPasswordButtonClick}
                        >
                            {trls[TrlKeys.action.loginByPassword]}
                        </Button>
                    </div>
                )}
                <Button
                    size="large"
                    style="accent"
                    mode={authMethod === AuthMethod.ByCode ? 'tertiary' : 'secondary'}
                    data-qa="account-login-no-access-email-back"
                    stretched
                    onClick={handleGoBackButtonClick}
                >
                    {trls[TrlKeys.action.goBack]}
                </Button>
            </VSpacingContainer>
        </VSpacingContainer>
    );
};

export default translation(TwoFactorGetHelpStep);
